import { ScreenshotType } from "@/domains/screenshot/types/screenshot.types";

export default class Screenshot {
  protected blob: Blob;

  protected type: ScreenshotType;

  public constructor(blob: Blob, type: ScreenshotType) {
    this.blob = blob;
    this.type = type;
  }

  public getBlob(): Blob {
    return this.blob;
  }

  public getBuffer(): Promise<ArrayBuffer> {
    return this.blob.arrayBuffer();
  }

  public async getBase64(): Promise<string> {
    const buffer = await this.getBuffer();
    const bytes = new Uint8Array(buffer);
    let binary = "";
    bytes.forEach((b: number): void => {
      binary += String.fromCharCode(b);
    });
    return btoa(binary); // Кодируем в Base64
  }

  public async getNumberArray(): Promise<number[]> {
    const arrayBuffer = await this.getBuffer();
    return Array.from(new Uint8Array(arrayBuffer));
  }
}
